import { SearchTermProps } from './TrendingSearchList.controller';

export const TOP_200_MOST_SEARCH_TERMS: SearchTermProps[] = [
  { searchText: 'le creuset', occurrences: 4809 },
  { searchText: 'cutting board', occurrences: 2610 },
  { searchText: 'caraway', occurrences: 2233 },
  { searchText: 'toaster', occurrences: 2165 },
  { searchText: 'flatware', occurrences: 1943 },
  { searchText: 'towels', occurrences: 1916 },
  { searchText: 'gift card', occurrences: 1910 },
  { searchText: 'blender', occurrences: 1886 },
  { searchText: 'luggage', occurrences: 1836 },
  { searchText: 'vacuum', occurrences: 1756 },
  { searchText: 'knife set', occurrences: 1730 },
  { searchText: 'wine glasses', occurrences: 1723 },
  { searchText: 'dyson', occurrences: 1702 },
  { searchText: 'air fryer', occurrences: 1698 },
  { searchText: 'dutch oven', occurrences: 1670 },
  { searchText: 'plates', occurrences: 1626 },
  { searchText: 'rice cooker', occurrences: 1620 },
  { searchText: 'yeti', occurrences: 1607 },
  { searchText: 'cooler', occurrences: 1600 },
  { searchText: 'kitchenaid', occurrences: 1599 },
  { searchText: 'all clad', occurrences: 1590 },
  { searchText: 'kitchen aid', occurrences: 1503 },
  { searchText: 'brooklinen', occurrences: 1493 },
  { searchText: 'silverware', occurrences: 1448 },
  { searchText: 'vase', occurrences: 1435 },
  { searchText: 'grill', occurrences: 1296 },
  { searchText: 'food processor', occurrences: 1266 },
  { searchText: 'knives', occurrences: 1230 },
  { searchText: 'vitamix', occurrences: 1612 },
  { searchText: 'salad bowl', occurrences: 1220 },
  { searchText: 'wok', occurrences: 1203 },
  { searchText: 'measuring cups', occurrences: 1190 },
  { searchText: 'mixing bowls', occurrences: 1174 },
  { searchText: 'parachute', occurrences: 1153 },
  { searchText: 'ninja', occurrences: 1092 },
  { searchText: 'kettle', occurrences: 1080 },
  { searchText: 'espresso machine', occurrences: 1076 },
  { searchText: 'air purifier', occurrences: 1028 },
  { searchText: 'smeg', occurrences: 1027 },
  { searchText: 'cast iron', occurrences: 1006 },
  { searchText: 'steamer', occurrences: 1003 },
  { searchText: 'trash can', occurrences: 996 },
  { searchText: 'sheets', occurrences: 995 },
  { searchText: 'espresso', occurrences: 993 },
  { searchText: 'coffee maker', occurrences: 983 },
  { searchText: 'beis', occurrences: 967 },
  { searchText: 'juicer', occurrences: 954 },
  { searchText: 'glasses', occurrences: 943 },
  { searchText: 'dinnerware', occurrences: 932 },
  { searchText: 'hexclad', occurrences: 1278 },
  { searchText: 'breville', occurrences: 931 },
  { searchText: 'oxo', occurrences: 931 },
  { searchText: 'pitcher', occurrences: 927 },
  { searchText: 'le cruset', occurrences: 926 },
  { searchText: 'kitchen towels', occurrences: 922 },
  { searchText: 'immersion blender', occurrences: 921 },
  { searchText: 'pyrex', occurrences: 1250 },
  { searchText: 'steak knives', occurrences: 916 },
  { searchText: 'cake stand', occurrences: 902 },
  { searchText: 'knife block', occurrences: 894 },
  { searchText: 'coffee', occurrences: 875 },
  { searchText: 'toaster oven', occurrences: 873 },
  { searchText: 'bath towels', occurrences: 866 },
  { searchText: 'fable', occurrences: 862 },
  { searchText: 'nespresso', occurrences: 862 },
  { searchText: 'lamp', occurrences: 854 },
  { searchText: 'salad spinner', occurrences: 854 },
  { searchText: 'rug', occurrences: 849 },
  { searchText: 'storage', occurrences: 847 },
  { searchText: 'electric kettle', occurrences: 846 },
  { searchText: 'towel warmer', occurrences: 844 },
  { searchText: 'staub', occurrences: 842 },
  { searchText: 'camping', occurrences: 835 },
  { searchText: 'iron', occurrences: 805 },
  { searchText: 'ooni', occurrences: 801 },
  { searchText: 'anthropologie', occurrences: 1112 },
  { searchText: 'pizza stone', occurrences: 797 },
  { searchText: 'coffee grinder', occurrences: 787 },
  { searchText: 'coffee table', occurrences: 780 },
  { searchText: 'food storage', occurrences: 769 },
  { searchText: 'honeymoon', occurrences: 1164 },
  { searchText: 'roomba', occurrences: 1062 },
  { searchText: 'our place', occurrences: 734 },
  { searchText: 'comforter', occurrences: 728 },
  { searchText: 'home depot', occurrences: 728 },
  { searchText: 'blackstone', occurrences: 817 },
  { searchText: 'tent', occurrences: 646 },
  { searchText: 'pajamas', occurrences: 484 },
  { searchText: 'pottery barn', occurrences: 630 },
  { searchText: 'record player', occurrences: 640 },
  { searchText: 'tupperware', occurrences: 650 },
  { searchText: 'meat thermometer', occurrences: 812 },
  { searchText: 'colander', occurrences: 550 },
  { searchText: 'spatula', occurrences: 603 },
  { searchText: 'ikea', occurrences: 577 },
  { searchText: 'couch', occurrences: 599 },
  { searchText: 'cat', occurrences: 524 },
  { searchText: 'crockpot', occurrences: 555 },
  { searchText: 'lego', occurrences: 517 },
  { searchText: 'costco', occurrences: 504 },
  { searchText: 'tongs', occurrences: 504 },
  { searchText: 'tv', occurrences: 550 },
  { searchText: 'mandolin', occurrences: 331 },
  { searchText: 'vaccum', occurrences: 331 },
  { searchText: 'onesie', occurrences: 328 },
  { searchText: 'footed pajamas', occurrences: 318 },
  { searchText: 'quince', occurrences: 425 },
  { searchText: 'hatch', occurrences: 416 },
  { searchText: 'frontgate', occurrences: 288 },
  { searchText: 'keurig', occurrences: 471 },
  { searchText: 'strainer', occurrences: 284 },
  { searchText: 'golf', occurrences: 387 },
  { searchText: 'tablecloth', occurrences: 280 },
  { searchText: 'williams sonoma', occurrences: 278 },
  { searchText: 'sous vide', occurrences: 277 },
  { searchText: 'apron', occurrences: 274 },
  { searchText: 'airfryer', occurrences: 270 },
  { searchText: 'nanit', occurrences: 268 },
  { searchText: 'compost', occurrences: 380 },
  { searchText: 'drill', occurrences: 263 },
  { searchText: 'whisk', occurrences: 459 },
  { searchText: 'thermometer', occurrences: 259 },
  { searchText: 'soda stream', occurrences: 258 },
  { searchText: 'bidet', occurrences: 251 },
  { searchText: 'dresser', occurrences: 398 },
  { searchText: 'airbnb', occurrences: 245 },
  { searchText: 'smoker', occurrences: 406 },
  { searchText: 'nordic ware', occurrences: 245 },
  { searchText: 'zojirushi', occurrences: 348 },
  { searchText: 'rei', occurrences: 375 },
  { searchText: 'ring', occurrences: 468 },
  { searchText: 'printer', occurrences: 339 },
  { searchText: 'lazy susan', occurrences: 232 },
  { searchText: 'litter robot', occurrences: 231 },
  { searchText: 'disney', occurrences: 391 },
  { searchText: 'mandoline', occurrences: 227 },
  { searchText: 'vaccuum', occurrences: 225 },
  { searchText: 'nutribullet', occurrences: 225 },
  { searchText: 'ruggable', occurrences: 324 },
  { searchText: 'japan', occurrences: 222 },
  { searchText: 'dewalt', occurrences: 221 },
  { searchText: 'bissell', occurrences: 335 },
  { searchText: 'newly named', occurrences: 562 },
  { searchText: 'grater', occurrences: 209 },
  { searchText: 'etsy', occurrences: 206 },
  { searchText: 'instapot', occurrences: 204 },
  { searchText: 'ramekin', occurrences: 204 },
  { searchText: 'bookshelf', occurrences: 194 },
  { searchText: 'cozy earth', occurrences: 176 },
  { searchText: 'planter', occurrences: 280 },
  { searchText: 'microplane', occurrences: 172 },
  { searchText: 'dehydrator', occurrences: 170 },
  { searchText: 'wagon', occurrences: 170 },
  { searchText: 'shun', occurrences: 169 },
  { searchText: 'hangers', occurrences: 169 },
  { searchText: 'greece', occurrences: 167 },
  { searchText: 'pickleball', occurrences: 162 },
  { searchText: 'theragun', occurrences: 160 },
  { searchText: 'irobot', occurrences: 160 },
  { searchText: 'ryobi', occurrences: 158 },
  { searchText: 'chopsticks', occurrences: 158 },
  { searchText: 'projector', occurrences: 155 },
  { searchText: 'chopper', occurrences: 155 },
  { searchText: 'nightstand', occurrences: 149 },
  { searchText: 'simplehuman', occurrences: 145 },
  { searchText: 'ramekins', occurrences: 143 },
  { searchText: 'mortar', occurrences: 138 },
  { searchText: 'soundbar', occurrences: 134 },
  { searchText: 'peeler', occurrences: 134 },
  { searchText: 'sofa', occurrences: 133 },
  { searchText: 'dehumidifier', occurrences: 132 },
  { searchText: 'cookbook', occurrences: 131 },
  { searchText: 'traeger', occurrences: 128 },
  { searchText: 'television', occurrences: 127 },
  { searchText: 'zester', occurrences: 124 },
  { searchText: 'firepit', occurrences: 123 },
  { searchText: 'delta', occurrences: 123 },
  { searchText: 'doormat', occurrences: 120 },
  { searchText: 'fan', occurrences: 120 },
  { searchText: 'dishware', occurrences: 113 },
  { searchText: 'corelle', occurrences: 111 },
  { searchText: 'll bean', occurrences: 109 },
  { searchText: 'menorah', occurrences: 108 },
  { searchText: 'garlic', occurrences: 106 },
  { searchText: 'fiestaware', occurrences: 105 },
  { searchText: 'moccamaster', occurrences: 105 },
  { searchText: 'meat tenderizer', occurrences: 105 },
  { searchText: 'oneida', occurrences: 105 },
  { searchText: 'trashcan', occurrences: 103 },
  { searchText: 'lemon squeezer', occurrences: 103 },
  { searchText: 'potato masher', occurrences: 102 },
  { searchText: 'coravin', occurrences: 100 },
  { searchText: 'fridge', occurrences: 98 },
  { searchText: 'victorinox', occurrences: 97 }
];
